import * as z from 'zod/mini'
import { Gender } from '../types'
import { emailField, isoDateOrDateTime } from './common'

/**
 * Personal details a premise keeps on its customers and employees, shared by the forms and the HTTP
 * bodies. Every field may be left empty - these records are often created from an email alone.
 *
 * `birthDate` is sent as the date picker gives it (`toISOString()` of local midnight) or as a plain
 * date; the service turns it into a `Date`, and `null` clears it.
 */
export const personFields = {
  firstName: z.string().check(z.trim(), z.maxLength(255)),
  lastName: z.string().check(z.trim(), z.maxLength(255)),
  phone: z.string().check(z.trim(), z.maxLength(255)),
  email: emailField,
  birthDate: z.nullable(isoDateOrDateTime),
  gender: z.enum(Gender),
  description: z.string().check(z.maxLength(50000)),
}
